// domain/services/coverageStatus.js
import { COVERAGE_STATUS } from '../constants/coverage';
import { includes, startsAfter } from '../model/EffectivePeriod';

/**
 * Derives a coverage's lifecycle as-of a date. Never persisted — a stored status silently rots
 * the moment the effective period rolls past it.
 *
 * Independent of the stored decisions: this answers "is the period current", nothing else.
 *
 * AN AS-OF THAT CANNOT BE READ GIVES ENDED, because both predicates below refuse it and ENDED is
 * what is left. That is the direction to fail in — an ended coverage is visible on the screen and
 * clearable, where an active one bills. It used to give ACTIVE for an open-bounded coverage, which
 * is the same omission failing the other way and nothing on the screen to show it.
 *
 * @param {import('../model/Coverage.types').Coverage} coverage
 * @param {string} asOf - 'YYYY-MM-DD'. Required: a rule that reads the clock itself is not a
 *   rule, it is a rule plus a hidden input. The edge decides what "now" means.
 * @returns {string} COVERAGE_STATUS
 */
// eslint-disable-next-line import/prefer-default-export
export function coverageStatus(coverage, asOf) {
  if (includes(coverage.period, asOf)) {
    return COVERAGE_STATUS.ACTIVE;
  }
  if (startsAfter(coverage.period, asOf)) {
    return COVERAGE_STATUS.UPCOMING;
  }

  return COVERAGE_STATUS.ENDED;
} // coverageStatus()
